// Silent Web NFC permission check — mirrors the reference provider kit's
// isNfcPermissionMissing() (packages/airkey-payment-provider-kit/app-src/src/App.jsx).
//
// Unlike NDEFReader.scan(), permissions.query() never prompts, so it is safe inside a
// Payment Handler window — where Chrome 149+ (CVE-2026-11108 fix) blocks the NFC prompt
// entirely. Used to decide up front whether the tap can complete here or must kick out
// to the enable-NFC interstitial. See docs/PAYMENT_HANDLER.md.

/**
 * Resolves true when NFC permission is NOT currently granted for this origin.
 *
 * A query that throws or is unsupported is treated as "not missing" (false), so the
 * tap screen can surface the real NDEFReader error instead of a premature kick-out.
 */
export async function isNfcPermissionMissing(): Promise<boolean> {
  try {
    const result = await navigator.permissions.query({
      name: 'nfc' as PermissionName,
    });
    return result.state !== 'granted';
  } catch {
    return false;
  }
}
